'use strict';

// polyfills HTMLElement.prototype.classList and DOMTokenList
require('classlist-polyfill');

// polyfills HTMLElement.prototype.hidden
require('./element-hidden');

// polyfills Number.isNaN()
require("./number-is-nan");

// polyfills CustomEvent
require("./custom-event");